import * as React from 'react';
import { ModalButton } from '../../../../shared/ui/modal-button/ModalButton';

interface ModalFooterProps {
  onSubmit: () => void;
  onClose: () => void;
  isSubmitDisabled?: boolean;
}

export const ModalFooter = ({
  onSubmit,
  onClose,
  isSubmitDisabled = false,
}: ModalFooterProps) => {
  return (
    <div className="modal-footer">
      <ModalButton
        className="btn-primary"
        onClick={onSubmit}
        disabled={isSubmitDisabled}
      >
        Ок
      </ModalButton>
      <ModalButton className="btn-default btn-secondary" onClick={onClose}>
        Отмена
      </ModalButton>
    </div>
  );
};
